import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Label, makeStyles, tokens } from "@fluentui/react-components";
import { Add16Filled } from "@fluentui/react-icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { checkUserPermission } from "../../../utils";
import { UserPermissionsList } from "../../../config";

import ContentLoader from "../../../components/Loader/ContentLoader";
import ASCButton from "../../../components/Button";
import {
  clearActiveItem,
  clearList,
  getVulnerabilityListItems,
} from "../../../redux/Client/vulnerability";
import NoDataFound from "../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({
  field: {
    display: "grid",
    gap: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalL,
  },
  wrapper: {
    display: "flex",
    justifyContent: "flex-end",
    margin: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalS} 0`,
  },
});

function VulnerabilityHomePage() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { clientId, selectedItemId, action } = useParams<{
    clientId: string;
    selectedItemId?: string;
    action?: string;
  }>();

  const { activeClient, vulnerability, authUser } = useSelector(
    (state: RootState) => ({
      activeClient: state.activeClient,
      vulnerability: state.vulnerability,
      authUser: state.authUser,
    })
  );

  const styles = useStyles();
  const API_PATH = `/clients/${clientId}/vulnerability`;

  useEffect(() => {
    dispatch(clearList());
    dispatch(clearActiveItem());
    if (clientId) {
      dispatch(getVulnerabilityListItems(clientId));
    }
  }, [dispatch, clientId]);

  useEffect(() => {
    const listItems = vulnerability.listItems;

    if (listItems.length > 0 && !selectedItemId) {
      navigate(
        `${API_PATH}/${listItems[0].vulnerability_id}/${action || "view"}`,
        { replace: true }
      );
    } else if (listItems.length === 0) {
      navigate(API_PATH, { replace: true });
    }
  }, [
    navigate,
    clientId,
    vulnerability.listItems,
    selectedItemId,
    action,
    API_PATH,
  ]);
  const canUpdateClient = checkUserPermission(
    authUser,
    UserPermissionsList.ALLOW_UPDATE_CLIENT
  );

  if (vulnerability.loading) {
    return <ContentLoader />;
  }

  if (vulnerability.listItems.length === 0) {
    return (
      <div>
        <div className={styles.wrapper}>
          {canUpdateClient && (
            <ASCButton
              shape="rounded"
              appearance="primary"
              className="asc-button-primary"
              icon={<Add16Filled />}
              size="medium"
              onClick={() => navigate(`${API_PATH}/add`)}
              label="Add New"
            />
          )}
        </div>
        <NoDataFound />
      </div>
    );
  }

  return null;
}

export default VulnerabilityHomePage;
